export const IMAGE_TYPES = [
    "other",
    "logo",
    "thumbnail",
    "poster",
    "banner",
    "cover",
];
export const RESOLUTIONS = ["SD", "HD", "UHD"];
export const MEDIA_RESOURCE_TYPES = [
    "native",
    "external",
];
export const STREAMING_PROTOCOLS = [
    "hls",
    "dash",
    "other",
];
export const MEDIA_TYPES = [
    "main",
    "trailer",
    "clip",
    "channel",
    "other",
];
export const TAG_TYPES = [
    "provider",
    "genre",
    "logo",
    "other",
];
export const ASSET_TYPES = [
    "movie",
    "series",
    "season",
    "episode",
    "channel",
];
export const SOURCE_TYPES = [
    "vod",
    "live",
    "catchup",
    "deeplink",
];
